/* eslint-disable react/prop-types */
import { Box, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import Button from "../../../common/Button";
import styles from "../style";
import MarkLoginOs from "./markLoginOs";

export const APPOINTMENT_RADIO = {
  DID_THE_COMMITTEE_MEET: "didTheCommitteeMeet",
};
const Styles = {
  position: "absolute",
  top: "369px",
  left: "712px",
  transform: "translate(-50%, -50%)",
  width: 760,
  height: 321,
  bgcolor: "background.paper",
  borderRadius: "10px",
  p: 4,
};

function MarkLoginModal({ member }) {
  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <>
      <Button label="Modal Button" onClick={handleOpen}>
        {" "}
      </Button>
      <Modal open={openModal} onClose={handleClose}>
        <div>
          <Formik
            enableReinitialize
            initialValues={{}}
            // onSubmit={(values) => {
            //   const dataToSend = { ...values };
            //   onReject(dataToSend);
            // }}
          >
            {({ values, errors, handleChange, setFieldValue }) => (
              <Box
                sx={Styles}
                style={{ paddingBottom: "5px", paddingLeft: "25px" }}
              >
                <Box marginTop="10px">
                  <Typography
                    style={{
                      color: "#8C8C8C",
                      fontSize: "20px ",
                      fontWeight: "500",
                    }}
                  >
                    Mark Login
                  </Typography>
                </Box>
                <Box>
                  <div style={{ padding: "30px 0px 0px 0px" }}>
                    <MarkLoginOs
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      member={member}
                    />
                  </div>
                </Box>
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="start"
                  padding="0px 0px 15px 0px"
                />
                <div style={{ display: "flex", gap: 10 }}>
                  <Button
                    variant="contained"
                    style={Styles.buttonStyle}
                    // onClick={handleSubmit}
                    type="submit"
                    label="Save"
                  />
                  <Button
                    variant="outlined"
                    style={styles.cancelBtn}
                    onClick={handleClose}
                    label="CANCEL"
                  />
                </div>
              </Box>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
}

export default MarkLoginModal;
